module.exports = __webpack_public_path__ + "2c6e65654566383e0f466cea5f708b27.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/head/hat-flowers-s.png
// module id = 2726
// module chunks = 0